import { AttributeModel } from "src/models";

export const orderDefaultAttributes = (attributes: AttributeModel[]) => {
  const fields = ["title", "detailedTitle", "price", "productType", "description", "quantity"];
  return fields
    .map((name) => attributes.find((attribute) => attribute.name === name))
    .filter(Boolean) as AttributeModel[];
};
